import { useEffect, useState } from "react";
import type { ViewMode } from "./ViewModeToggle.js";

const PREFIX = "mmm-view-mode:";

function readViewMode(key: string, fallback: ViewMode): ViewMode {
  const stored = localStorage.getItem(`${PREFIX}${key}`);
  return stored === "grid" || stored === "list" ? stored : fallback;
}

export function usePersistedViewMode(key: string, fallback: ViewMode = "grid") {
  const [value, setValue] = useState<ViewMode>(() => readViewMode(key, fallback));

  useEffect(() => {
    localStorage.setItem(`${PREFIX}${key}`, value);
  }, [key, value]);

  return [value, setValue] as const;
}
